export const PublicEngagementUrlUtil = (path: string) => {
  return {
    toPublic: () => {
      const bits = path.split('/');

      const lastIndex = bits.length - 1;
      const secondLastIndex = bits.length - 2;

      if (bits.at(lastIndex) === 'matches') {
        bits[lastIndex] = 'engagement';
      } else if (bits.at(secondLastIndex) === 'matches') {
        bits[secondLastIndex] = 'engagement';
      }

      return bits.join('/');
    },
    fromPublic: () => {
      const bits = path.split('/');

      const lastIndex = bits.length - 1;
      const secondLastIndex = bits.length - 2;

      if (bits.at(lastIndex) === 'engagement') {
        bits[lastIndex] = 'matches';
      } else if (bits.at(secondLastIndex) === 'engagement') {
        bits[secondLastIndex] = 'matches';
      }

      return bits.join('/');
    },
    fromPublicMatchesToInterviews: () => {
      const bits = path.split('/');

      const lastIndex = bits.length - 1;
      const secondLastIndex = bits.length - 2;

      if (bits.at(lastIndex) === 'engagement') {
        bits[lastIndex] = 'interviews';
      } else if (bits.at(secondLastIndex) === 'engagement') {
        bits[secondLastIndex] = 'interviews';
      }

      return bits.join('/');
    },
  };
};
